import Input from './Input';

export { default as InputAutocomplete } from './InputAutocomplete';

export { default as InputSearch } from './InputSearch';

export default Input;
